/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  APIPaginatedRequestFileList,
  APIRequestFile,
} from '../models/index';
import {
    APIPaginatedRequestFileListFromJSON,
    APIPaginatedRequestFileListToJSON,
    APIRequestFileFromJSON,
    APIRequestFileToJSON,
} from '../models/index';

export interface V1RequestFilesCreateRequest {
    request: string;
    key?: string | null;
    document?: Blob | null;
}

export interface V1RequestFilesDestroyRequest {
    id: number;
}

export interface V1RequestFilesListRequest {
    page?: number;
    pageSize?: number;
}

export interface V1RequestFilesPartialUpdateRequest {
    id: number;
    request?: string;
    key?: string | null;
    document?: Blob | null;
}

export interface V1RequestFilesRetrieveRequest {
    id: number;
}

export interface V1RequestFilesUpdateRequest {
    id: number;
    request: string;
    key?: string | null;
    document?: Blob | null;
}

export interface V1RequestRequestsFilesCreateRequest {
    requestPk: number;
    request: string;
    key?: string | null;
    document?: Blob | null;
}

export interface V1RequestRequestsFilesDestroyRequest {
    id: number;
    requestPk: number;
}

export interface V1RequestRequestsFilesListRequest {
    requestPk: number;
    page?: number;
    pageSize?: number;
}

export interface V1RequestRequestsFilesPartialUpdateRequest {
    id: number;
    requestPk: number;
    request?: string;
    key?: string | null;
    document?: Blob | null;
}

export interface V1RequestRequestsFilesRetrieveRequest {
    id: number;
    requestPk: number;
}

export interface V1RequestRequestsFilesUpdateRequest {
    id: number;
    requestPk: number;
    request: string;
    key?: string | null;
    document?: Blob | null;
}

/**
 * 
 */
export class RequestrequestFileApi extends runtime.BaseAPI {

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestFilesCreateRaw(requestParameters: V1RequestFilesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRequestFile>> {
        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling v1RequestFilesCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['request'] != null) {
            formParams.append('request', requestParameters['request'] as any);
        }

        if (requestParameters['key'] != null) {
            formParams.append('key', requestParameters['key'] as any);
        }

        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document'] as any);
        }

        const response = await this.request({
            path: `/v1/request/files/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRequestFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestFilesCreate(requestParameters: V1RequestFilesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRequestFile> {
        const response = await this.v1RequestFilesCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestFilesDestroyRaw(requestParameters: V1RequestFilesDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestFilesDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/files/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestFilesDestroy(requestParameters: V1RequestFilesDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v1RequestFilesDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestFilesListRaw(requestParameters: V1RequestFilesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIPaginatedRequestFileList>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/files/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIPaginatedRequestFileListFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestFilesList(requestParameters: V1RequestFilesListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIPaginatedRequestFileList> {
        const response = await this.v1RequestFilesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestFilesPartialUpdateRaw(requestParameters: V1RequestFilesPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRequestFile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestFilesPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['request'] != null) {
            formParams.append('request', requestParameters['request'] as any);
        }

        if (requestParameters['key'] != null) {
            formParams.append('key', requestParameters['key'] as any);
        }

        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document'] as any);
        }

        const response = await this.request({
            path: `/v1/request/files/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRequestFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestFilesPartialUpdate(requestParameters: V1RequestFilesPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRequestFile> {
        const response = await this.v1RequestFilesPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestFilesRetrieveRaw(requestParameters: V1RequestFilesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRequestFile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestFilesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/files/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRequestFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestFilesRetrieve(requestParameters: V1RequestFilesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRequestFile> {
        const response = await this.v1RequestFilesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestFilesUpdateRaw(requestParameters: V1RequestFilesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRequestFile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestFilesUpdate().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling v1RequestFilesUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['request'] != null) {
            formParams.append('request', requestParameters['request'] as any);
        }

        if (requestParameters['key'] != null) {
            formParams.append('key', requestParameters['key'] as any);
        }

        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document'] as any);
        }

        const response = await this.request({
            path: `/v1/request/files/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRequestFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestFilesUpdate(requestParameters: V1RequestFilesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRequestFile> {
        const response = await this.v1RequestFilesUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestRequestsFilesCreateRaw(requestParameters: V1RequestRequestsFilesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRequestFile>> {
        if (requestParameters['requestPk'] == null) {
            throw new runtime.RequiredError(
                'requestPk',
                'Required parameter "requestPk" was null or undefined when calling v1RequestRequestsFilesCreate().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling v1RequestRequestsFilesCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['request'] != null) {
            formParams.append('request', requestParameters['request'] as any);
        }

        if (requestParameters['key'] != null) {
            formParams.append('key', requestParameters['key'] as any);
        }

        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document'] as any);
        }

        const response = await this.request({
            path: `/v1/request/requests/{request_pk}/files/`.replace(`{${"request_pk"}}`, encodeURIComponent(String(requestParameters['requestPk']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRequestFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestRequestsFilesCreate(requestParameters: V1RequestRequestsFilesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRequestFile> {
        const response = await this.v1RequestRequestsFilesCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestRequestsFilesDestroyRaw(requestParameters: V1RequestRequestsFilesDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestRequestsFilesDestroy().'
            );
        }

        if (requestParameters['requestPk'] == null) {
            throw new runtime.RequiredError(
                'requestPk',
                'Required parameter "requestPk" was null or undefined when calling v1RequestRequestsFilesDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/requests/{request_pk}/files/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"request_pk"}}`, encodeURIComponent(String(requestParameters['requestPk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestRequestsFilesDestroy(requestParameters: V1RequestRequestsFilesDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v1RequestRequestsFilesDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestRequestsFilesListRaw(requestParameters: V1RequestRequestsFilesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIPaginatedRequestFileList>> {
        if (requestParameters['requestPk'] == null) {
            throw new runtime.RequiredError(
                'requestPk',
                'Required parameter "requestPk" was null or undefined when calling v1RequestRequestsFilesList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/requests/{request_pk}/files/`.replace(`{${"request_pk"}}`, encodeURIComponent(String(requestParameters['requestPk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIPaginatedRequestFileListFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestRequestsFilesList(requestParameters: V1RequestRequestsFilesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIPaginatedRequestFileList> {
        const response = await this.v1RequestRequestsFilesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestRequestsFilesPartialUpdateRaw(requestParameters: V1RequestRequestsFilesPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRequestFile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestRequestsFilesPartialUpdate().'
            );
        }

        if (requestParameters['requestPk'] == null) {
            throw new runtime.RequiredError(
                'requestPk',
                'Required parameter "requestPk" was null or undefined when calling v1RequestRequestsFilesPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['request'] != null) {
            formParams.append('request', requestParameters['request'] as any);
        }

        if (requestParameters['key'] != null) {
            formParams.append('key', requestParameters['key'] as any);
        }

        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document'] as any);
        }

        const response = await this.request({
            path: `/v1/request/requests/{request_pk}/files/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"request_pk"}}`, encodeURIComponent(String(requestParameters['requestPk']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRequestFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestRequestsFilesPartialUpdate(requestParameters: V1RequestRequestsFilesPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRequestFile> {
        const response = await this.v1RequestRequestsFilesPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestRequestsFilesRetrieveRaw(requestParameters: V1RequestRequestsFilesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRequestFile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestRequestsFilesRetrieve().'
            );
        }

        if (requestParameters['requestPk'] == null) {
            throw new runtime.RequiredError(
                'requestPk',
                'Required parameter "requestPk" was null or undefined when calling v1RequestRequestsFilesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/request/requests/{request_pk}/files/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"request_pk"}}`, encodeURIComponent(String(requestParameters['requestPk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRequestFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestRequestsFilesRetrieve(requestParameters: V1RequestRequestsFilesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRequestFile> {
        const response = await this.v1RequestRequestsFilesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestRequestsFilesUpdateRaw(requestParameters: V1RequestRequestsFilesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRequestFile>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1RequestRequestsFilesUpdate().'
            );
        }

        if (requestParameters['requestPk'] == null) {
            throw new runtime.RequiredError(
                'requestPk',
                'Required parameter "requestPk" was null or undefined when calling v1RequestRequestsFilesUpdate().'
            );
        }

        if (requestParameters['request'] == null) {
            throw new runtime.RequiredError(
                'request',
                'Required parameter "request" was null or undefined when calling v1RequestRequestsFilesUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['request'] != null) {
            formParams.append('request', requestParameters['request'] as any);
        }

        if (requestParameters['key'] != null) {
            formParams.append('key', requestParameters['key'] as any);
        }

        if (requestParameters['document'] != null) {
            formParams.append('document', requestParameters['document'] as any);
        }

        const response = await this.request({
            path: `/v1/request/requests/{request_pk}/files/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"request_pk"}}`, encodeURIComponent(String(requestParameters['requestPk']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRequestFileFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1RequestRequestsFilesUpdate(requestParameters: V1RequestRequestsFilesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRequestFile> {
        const response = await this.v1RequestRequestsFilesUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
